export enum KPI_SUB_TYPES {
  ABSOLUTE = 'ABSOLUTE',
  PERCENTAGE = 'PERCENTAGE',
}

export enum KPI_F_TYPE {
  VARIABLE = 'VARIABLE',
  FIXED = 'FIXED',
}
